<template>
  <div class="home-box">
    <div class="home-texts">
      <div v-for="(text, index) in [1,2]" :key="text" :index="index" :item="text" v-if="loading">
        <div class="invest" v-if="index%2 === 0">
          <div class="page loader">
            <loader :light="true"/>
          </div>
        </div>
        <div class="pro" v-else>
          <div class="page loader">
            <loader :light="false"/>
          </div>
        </div>
      </div>
      <div v-for="(text, index) in texts" :key="index" :index="index" :item="text" v-if="!loading">
        <div class="pro" v-if="index % 2 === 0">
          <div class="container">
            <div class="page">
              <div class="page-img">
                <img :src="text.picture">
              </div>
              <div class="text-pro">
                <h2 class="titlesection">{{text.title}}</h2>
                <h3 class="titlesection">{{text.subtitle}}</h3>
                <p>{{text.content}}</p>
                <div class="room-discover">
                  <router-link tag="a" :to="{name: 'invest'}" class="colored-btn yellow-green-btn">
                    <span>{{text.button_text}}</span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="invest" v-else>
          <div class="container">
            <div class="page grid-invest">
              <div class="text-invest">
                <h2 class="titlesection">{{text.title}}</h2>
                <h3 class="titlesection">{{text.subtitle}}</h3>
                <p>{{text.content}}</p>
                <div class="room-discover">
                  <router-link tag="a" :to="{name: 'pro'}" class="red-btn" :class="{ 'card-button' : width >= 1024, 'colored-btn' : width < 1024 }">
                    <span>{{text.button_text}}</span>
                  </router-link>
                </div>
              </div>
              <div class="as-image" :style="`background-image: url(${text.picture})`"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import Loader from '../../components/loader.component'

  export default {
    name: 'home-texts',
    components: {Loader},
    async created() {
      await this.$store.dispatch('homeTexts/fetch', {lang: this.$store.state.lang.currentLang});
    },
    data () {
      return {
        classActivate : false,
      }
    },
    computed: {
      width() {
        return window.innerWidth;
      },

      ...mapState({
        loading: state => state.homeTexts.loading,
        texts: state => state.homeTexts.texts,
      }),
    },

    watch: {
      width: function () {
        this.classActivate = this.width < 1024;
      }
    }
  };
</script>

<style scoped>
  .loader {
    height: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/home-texts.vue